import React from "react";
import { FaLayerGroup, FaPen, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./ProductTable.css";

const ProductTable = ({ products = [], onEdit, onDelete, canWrite = true }) => {
  const navigate = useNavigate();

  if (products.length === 0) return (
    <div className="no-variants-message">
      <p>No products available.</p>
    </div>
  );

  return (
    <div className="luxury-table-container">
      <table className="luxury-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Product Name</th>
            <th>Category</th>
            <th>Type</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) => (
            <tr key={p.id || p._id}>
              <td>
                <div className="product-images-container">
                  {p.p_images && p.p_images.length > 0 ? (
                    p.p_images.map((img, idx) => (
                      <div key={idx} className="product-thumbnail">
                        <img
                          src={typeof img === 'object' ? img.url : img}
                          alt={`${p.p_name} ${idx}`}
                        />
                      </div>
                    ))
                  ) : (
                    <div className="product-thumbnail">
                      <span className="placeholder-icon">📦</span>
                    </div>
                  )}
                </div>
              </td>
              <td style={{ fontWeight: "700", color: "#181c32" }}>{p.p_name}</td>
              <td>{p.p_category || "-"}</td>
              <td>
                <span className={`status-badge type-${p.p_Product_Type}`}>
                  {p.p_Product_Type}
                </span>
              </td>
              <td>
                <div className="table-actions">
                  <button
                    className="action-btn view"
                    onClick={() => navigate(`/adminDashboard/variant/${p._id || p.id}`)}
                    title="View Variants"
                  >
                    <FaLayerGroup />
                  </button>
                  {canWrite && (
                    <>
                      <button className="action-btn edit" onClick={() => onEdit(p)} title="Edit Product">
                        <FaPen />
                      </button>
                      <button className="action-btn delete" onClick={() => onDelete(p._id || p.id)} title="Delete Product">
                        <FaTrash />
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;
